import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import UniversesSection from './components/UniversesSection';
import FounderSection from './components/FounderSection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';
import LogoIntro from './components/LogoIntro';

const HomePage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <>
      <LogoIntro />
      <div
        className="min-h-screen bg-[#0A0A0A]"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        <Header />
        <main>
          <HeroSection />
          <UniversesSection />
          <AboutSection />
          <FounderSection />
          <PortfolioSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
